/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CardPhoto, Modal } from '../../components';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const SrtyledWrapCard = styled.div`
  text-align: center;
  cursor: pointer;
`;

const StyledCardPhoto = ({
  onClick,
  photo,
  title,
  subtitle,
  isId,
  positionId,
  positionEn,
}: any) => (
  <SrtyledWrapCard onClick={onClick}>
    <CardPhoto src={`${process.env.REACT_APP_URL}/images/${photo}`} />
    <Typography
      variant='h6'
      color='textPrimary'
      style={{ marginTop: '.5rem', fontWeight: 600 }}
    >
      {title}
    </Typography>
    <Typography color='primary' style={{ fontSize: 18, fontWeight: 600 }}>
      {isId ? positionId : positionEn}
    </Typography>
    <Typography
      color='textSecondary'
      style={{
        maxWidth: 200,
        lineHeight: '1.5em',
        height: '7.5em',
        overflow: 'hidden',
      }}
    >
      {subtitle}
    </Typography>
  </SrtyledWrapCard>
);

const StrukturOrganisasi = ({ isId }: any) => {
  const [directorState, setDirectorState] = useState<any>(null);
  const [commisaryState, setCommisaryState] = useState<any>(null);
  const [loadingState, setLoadingState] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [dataModal, setDataModal] = useState({
    title: '',
    subtitle: '',
    photo: '',
    content: '',
  });

  const handleOpenModal = (data: any) => {
    const { name, photo, position_id, position_en, text_id, text_en } = data;
    setDataModal({
      title: name,
      subtitle: isId ? position_id : position_en,
      photo: `${process.env.REACT_APP_URL}/images/${photo}`,
      content: isId ? text_id : text_en,
    });
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  const fetchDewan = async (type: number) => {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content/dewan?type=${type}`
    );
    const resJson = await res.json();
    if (type === 1) {
      setDirectorState(resJson.data.rows);
    }
    if (type === 2) {
      setCommisaryState(resJson.data.rows);
    }
  };

  const firstLoad = async () => {
    try {
      await fetchDewan(1);
      await fetchDewan(2);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    firstLoad();
  }, []);

  return (
    <>
      <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 16px' }}>
        <Typography style={{ marginBottom: '4rem' }}>
          {isId ? 'Tentang Kami' : 'About Us'}
          &nbsp; &gt; &nbsp;{' '}
          <span style={{ color: '#e3232a' }}>
            {isId ? 'Struktur Organisasi' : 'Organization Structure'}
          </span>
        </Typography>
      </div>

      <div style={{ maxWidth: 1280, margin: '0 auto', paddingBottom: '7rem' }}>
        <Typography
          align='center'
          color='primary'
          variant='h4'
          style={{ marginBottom: '4rem' }}
        >
          Board of Commisary
        </Typography>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 32,
            flexWrap: 'wrap',
          }}
        >
          {loadingState
            ? [1, 2, 3].map(() => (
                <div>
                  <Skeleton
                    variant='rect'
                    width={200}
                    height={270}
                    style={{ marginBottom: 16 }}
                  />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                </div>
              ))
            : commisaryState.map((row: any) => (
                <StyledCardPhoto
                  key={row.id}
                  photo={row.photo}
                  title={row.name}
                  subtitle={isId ? row.text_id : row.text_en}
                  onClick={() => handleOpenModal(row)}
                  isId={isId}
                  positionId={row.position_id}
                  positionEn={row.position_en}
                />
              ))}
        </div>
      </div>
      <div
        style={{
          backgroundColor: '#f0f0f0',
          padding: '4rem 16px',
          paddingBottom: '6rem',
        }}
      >
        <Typography
          align='center'
          color='primary'
          variant='h4'
          style={{ marginBottom: '4rem' }}
        >
          Board of Director
        </Typography>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 32,
            flexWrap: 'wrap',
          }}
        >
          {loadingState
            ? [1, 2, 3].map(() => (
                <div>
                  <Skeleton
                    variant='rect'
                    width={200}
                    height={270}
                    style={{ marginBottom: 16 }}
                  />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                </div>
              ))
            : directorState.map((row: any) => (
                <StyledCardPhoto
                  key={row.id}
                  photo={row.photo}
                  title={row.name}
                  subtitle={isId ? row.text_id : row.text_en}
                  onClick={() => handleOpenModal(row)}
                  isId={isId}
                  positionId={row.position_id}
                  positionEn={row.position_en}
                />
              ))}
        </div>
        <Modal
          isOpen={openModal}
          onRequestClose={handleCloseModal}
          title={dataModal.title}
          subtitle={dataModal.subtitle}
          photo={dataModal.photo}
          content={dataModal.content}
        />
      </div>
    </>
  );
};

export default StrukturOrganisasi;
